<template>
  <ul class="py-4 h-full bg-stone-900 text-white space-y-4 w-64">
    <!-- Sidebar content here -->
    <sidebar-menu
      v-for="(item, index) in items"
      :key="index"
      :item="item"
      :class="{ hidden: !item.condition }"
    />
  </ul>
</template>

<script setup>
import SidebarMenu from "./SidebarMenu.vue";

import useMiddleware from "../../helper/hooks/useMiddleware";

import { ref } from "vue";

const { isAdmin } = useMiddleware();

const items = ref([
  {
    condition: true,
    routeName: "home",
    title: "Beranda",
    icon: ["fas", "gauge-high"],
  },
  {
    condition: isAdmin,
    routeName: "health-monitoring",
    title: "Health Monitoring",
    icon: ["fas", "heart-pulse"],
  },
  {
    condition: isAdmin,
    routeName: "dashboardTransaction",
    title: "Dashboard Transaksi",
    icon: ["fas", "chart-simple"],
  },
  {
    condition: true,
    routeName: "notification",
    title: "Notifikasi",
    icon: ["fas", "bell"],
  },
  {
    condition: true,
    title: "Dokumen",
    collapse: false,
    subItem: [
      {
        condition: true,
        routeName: "documents",
        title: "Dokumen Saya",
        icon: ["far", "file"],
      },
      {
        condition: true,
        routeName: "submission",
        title: "Status Pengajuan",
        icon: ["far", "circle-check"],
      },
      // {
      //   condition: true,
      //   routeName: "totpActivation",
      //   title: "Aktivasi TOTP",
      //   icon: ["fas", "key"], 
      // },
      {
        condition: true,
        title: "Butuh Tanda Tangan",
        collapse: false,
        subItem: [
          {
          condition: true,
          routeName: "needSignElectronic",
          title: "Tanda Tangan Elektronik",
          icon: ["fas", "exclamation"],
          smallFont: true,
        },
        // {
        //   condition: true,
        //   routeName: "needSignDigital",
        //   title: "Tanda Tangan Digital",
        //   icon: ["fas", "exclamation"],
        // },
      ],
    },
    {
      condition: true,
      routeName: "signed",
      title: "Telah Ditanda Tangan",
      icon: ["fas", "check"],
      smallFont: true,
    },
      {
        condition: true,
        routeName: "recycleBin",
        title: "Recycle Bin",
        icon: ["fas", "trash-can"],
      },
      // {
      //   condition: true,
      //   routeName: "checkLegality",
      //   title: "Cek Legalitas Dokumen",
      //   muted: false,
      //   icon: ["far", "circle-check"],
      // },
    ],
  },
  // {
  //   condition: true,
  //   routeName: "template",
  //   title: "Templates",
  //   icon: ["far", "file"],
  // },
  {
    condition: isAdmin,
    routeName: "users",
    title: "Pengguna",
    icon: ["fas", "users"],
  },
  {
    condition: isAdmin,
    routeName: "logs",
    title: "Riwayat BSRE",
    icon: ["fas", "clock-rotate-left"],
  },
  {
    condition: true,
    routeName: "settings",
    title: "Pengaturan",
    icon: ["fas", "gear"],
  },
]);
</script>
